<!-- =========================================================================================
    File Name: Chat.vue
    Description: Chat Application - Stay connected
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="chat-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <vs-sidebar class="items-no-padding" parent="#chat-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isChatSidebarActive" id="chat-list-sidebar">
      <!-- USER PROFILE SIDEBAR -->
      <!-- <user-profile :active="activeProfileSidebar" :userId="userProfileId" class="user-profile-container" :isLoggedInUser="isLoggedInUserProfileView" @closeProfileSidebar="closeProfileSidebar"></user-profile> -->

      <!-- <div class="chat__profile-search flex p-4">
                <div class="relative inline-flex">
                    <vs-avatar v-if="activeUser.photoURL" class="m-0 border-2 border-solid border-white" :src="activeUser.photoURL" size="40px" @click="showProfileSidebar(Number(activeUser.uid), true)" />
                    <div class="h-3 w-3 border-white border border-solid rounded-full absolute right-0 bottom-0" :class="'bg-' + getStatusColor(true)"></div>
                </div>
                <vs-input icon-no-border icon="icon-search" icon-pack="feather" class="w-full mx-5 input-rounded-full" placeholder="Search or start a new chat" v-model="searchQuery"/>

                <feather-icon class="md:inline-flex lg:hidden -ml-3 cursor-pointer" icon="XIcon" @click="toggleChatSidebar(false)" />
            </div> -->

            <!-- <vs-divider class="d-theme-border-grey-light m-0" /> -->
      <component
        :is="scrollbarTag"
        class="chat-scroll-area pt-4"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="pl-5 pb-1">
          <!-- <vs-button
            size="small"
            type="border"
            @click="callSelected('student')"
            ref="btn"
            >Students</vs-button
          >
          <vs-button
            size="small"
            type="border"
            @click="callSelected('manager')"
            ref="btn2"
            >Staff</vs-button
          > -->
        </div>

        <!-- ACTIVE CHATS LIST -->
        <div class="chat__chats-list">
          <h4 class="text-primary mb-1 px-4">
            <vs-radio v-model="selected" @change="activeChatUser=null" vs-value="student">{{ $t('student.profile.students') }}</vs-radio>
            &nbsp;
            <vs-radio v-model="selected"  @change="activeChatUser=null" vs-value="manager"  v-if="role!=='user'">Programs</vs-radio>
          </h4>
          
         <div v-if="selected === 'student' && studentcontacts">
          <ul
            class="chat__active-chats bordered-items"
            
          >
            <li
              class="cursor-pointer"
              v-for="(contact, index) in studentcontacts"
              :key="index"
              @click="updateActiveChatUser(contact)"
            >
              <chat-contact
                :id="'div' + index + 'li'"
                :ref="'div' + index + 'li'"
                showLastMsg
                :contact="contact"
                :meID="meID"
                :lastMessaged="chatLastMessaged(contact.id).time"
                :unseenMsg="chatUnseenMessages(contact.id)"
                :isActiveChatUser="isActiveChatUser(contact.id)"
              ></chat-contact>
            </li>
          </ul>
          <p class="text-center" v-if="studentcontactslength === 0">No Chat</p>
          </div> 
          <div v-if="selected === 'manager' && programcontact">
          <ul
            class="chat__active-chats bordered-items"
            
          >
            <li
              class="cursor-pointer"
              v-for="(contact, index) in programcontact"
              :key="index"
              @click="updateActiveChatUser(contact)"
            >
              <chat-program
                :id="'div' + index + 'li'"
                :ref="'div' + index + 'li'"
                showLastMsg
                :contact="contact"
                :lastMessaged="chatLastMessaged(contact.id).time"
                :unseenMsg="chatUnseenMessages(contact.id)"
                :isActiveChatUser="isActiveChatUser(contact.id)"
              ></chat-program>
            </li>
          </ul>
          <p class="text-center" v-if="programcontactslength === 0 && role!=='user'">No Chat</p>
        </div>
        </div>
      </component><br>
          <a class="ml-10" v-if="role!=='user'" @click="addNewData()" style="cursor:pointer">Add new Alert</a>
    </vs-sidebar>
    <!-- RIGHT COLUMN -->
    <div
      class="chat__bg no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0"
      :class="{
        'sidebar-spacer--wide': clickNotClose,
        'flex items-center justify-center': activeChatUser === null,
      }"
      v-if="selected === 'student'"
    >
      <template v-if="activeChatUser">
        <div class="chat__navbar">
          <chat-navbar :isSidebarCollapsed="!clickNotClose" :user="activeChatUser" :isPinnedProp="isChatPinned" @openContactsSidebar="toggleChatSidebar(true)" @showProfileSidebar="showProfileSidebar" @toggleIsChatPinned="toggleIsChatPinned"></chat-navbar>
        </div>
        <component
          :is="scrollbarTag"
          class="chat-content-scroll-area border border-solid d-theme-border-grey-light"
          :settings="settings"
          ref="chatLogPS"
          :key="$vs.rtl"
        >
          <div class="chat__log" ref="chatLog">
            <chat-log
               @markread="markread"
              :chatloader="chatloader"
              :user="activeChatUser"
              :chat_data="userChatData"
               v-if="activeChatUser"
            ></chat-log>
          </div>
        </component>
        <div class="chat__input flex p-4 bg-white">
          <vs-input
            class="flex-1"
            placeholder="Type Your Message"
            v-model="typedMessage"
            @keyup.enter="sendMsg"
          />
          <span
            :id="'div-with-'"
            class="vs-con-loading__container flex"
            :ref="'div-with-'"
          >
            <input
              type="file"
              multiple
              class="hidden"
              ref="updatefileInput"
              @change="uploadFile"
              accept="*" />
            <feather-icon
              icon="PaperclipIcon"
              class="ml-1"
              @click="$refs.updatefileInput.click()"
            ></feather-icon
          ></span>
          <vs-button
            class="bg-primary-gradient ml-1"
            type="filled"
            :disabled="!isFormValidMessage"
            @click.native="sendMsg"
            >Send</vs-button
          >
        </div>
        <div>
          <span v-for="(file, index) in uplodedfiles" :key="index" class="p-5">
            <vs-chip
              @click="removefile(index)"
              closable
              class="leading-none font-medium"
              >{{ file.orignal }}</vs-chip
            >
          </span>
          <br /><br />
          <span v-if="largeFile.length > 0" class="text-danger text-sm"
            >Large Files</span
          ><br />
          <ul v-for="(file, i) in largeFile" :key="i">
            <li>
              <vs-chip class="leading-none font-medium">{{ file }}</vs-chip>
            </li>
          </ul>
        </div>
      </template>
      <template v-else>
        <div class="flex flex-col items-center">
          <feather-icon
            icon="MessageSquareIcon"
            class="mb-4 bg-white p-8 shadow-md rounded-full"
            svgClasses="w-16 h-16"
          ></feather-icon>
          <h4
            v-if="meRole !== 'user' && clickNotClose"
            class="py-2 px-4 bg-white shadow-md rounded-full cursor-pointer"
            @click="addNewData()"
          >
            Add New Alert
          </h4>
          <h4
            v-else
            class="py-2 px-4 bg-white shadow-md rounded-full cursor-pointer"
            @click="toggleChatSidebar(true)"
          >
            Start Conversation
          </h4>
        </div>
      </template>
    </div>

    <div
      class="chat__bg no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0"
      :class="{
        'sidebar-spacer--wide': clickNotClose,
        'flex items-center justify-center': activeChatUser === null,
      }"
      v-if="selected === 'manager'"
    >
      <template v-if="activeChatUser">
        <div class="chat__navbar">
          <chat-program-navbar :isSidebarCollapsed="!clickNotClose" :user="activeChatUser"  :isPinnedProp="isChatPinned" @openContactsSidebar="toggleChatSidebar(true)" @showProfileSidebar="showProfileSidebar" @toggleIsChatPinned="toggleIsChatPinned"></chat-program-navbar>
        </div>
        <component
          :is="scrollbarTag"
          class="chat-content-scroll-area border border-solid d-theme-border-grey-light"
          :settings="settings"
          ref="chatLogPS"
          :key="$vs.rtl"
        >
          <div class="chat__log" ref="chatLog">
            <chat-log
              :chatloader="chatloader"
              :user="activeChatUser"
              :chat_data="userChatData"
              v-if="activeChatUser"
            ></chat-log>
          </div>
        </component>
        <div class="chat__input flex p-4 bg-white">
          <vs-input
            class="flex-1"
            placeholder="Type Your Message"
            v-model="typedMessage"
            @keyup.enter="sendMsg"
          />
          <span
            :id="'div-with-'"
            class="vs-con-loading__container flex"
            :ref="'div-with-'"
          >
            <input
              type="file"
              multiple
              class="hidden"
              ref="updatefileInput"
              @change="uploadFile"
              accept="*" />
            <feather-icon
              icon="PaperclipIcon"
              class="ml-1"
              @click="$refs.updatefileInput.click()"
            ></feather-icon
          ></span>
          <vs-button
            class="bg-primary-gradient ml-1"
            type="filled"
            :disabled="!isFormValidMessage"
            @click.native="sendMsg"
            >Send</vs-button
          >
        </div>
        <div>
          <span v-for="(file, index) in uplodedfiles" :key="index" class="p-5">
            <vs-chip
              @click="removefile(index)"
              closable
              class="leading-none font-medium"
              >{{ file.orignal }}</vs-chip
            >
          </span>
          <br /><br />
          <span v-if="largeFile.length > 0" class="text-danger text-sm"
            >Large Files</span
          ><br />
          <ul v-for="(file, i) in largeFile" :key="i">
            <li>
              <vs-chip class="leading-none font-medium">{{ file }}</vs-chip>
            </li>
          </ul>
        </div>
      </template>
        <template v-else>
        <div class="flex flex-col items-center">
          <feather-icon
            icon="MessageSquareIcon"
            class="mb-4 bg-white p-8 shadow-md rounded-full"
            svgClasses="w-16 h-16"
          ></feather-icon>
          <h4
            v-if="meRole !== 'user' && clickNotClose"
            class="py-2 px-4 bg-white shadow-md rounded-full cursor-pointer"
            @click="addNewData()"
          >
            Add New Alert
          </h4>
          <h4
            v-else
            class="py-2 px-4 bg-white shadow-md rounded-full cursor-pointer"
            @click="toggleChatSidebar(true)"
          >
            Start Conversation
          </h4>
        </div>
      </template>
    </div>
     <vs-popup class="holamundo" title="Add new Alert" :active.sync="AlertPopup">
      <div class="p-6 pt-0">
        <div>
          <vs-radio v-model="typeData"  vs-name="radios1" vs-value="type_student">Students</vs-radio>
          &nbsp;
          <vs-radio v-model="typeData"  vs-name="radios1" vs-value="type_manager">Staff</vs-radio>
        </div>
        <label class="vs-select--label w-full">Select Location *</label>
        <label
          class="ml-5 vs-select--label"
          @click="allLocation"
          style="float: right"
          >Select All</label
        >
        <v-select autocomplete="off"
          label="name"
          name="locations"
          multiple
          @input="getProgram()"
          :closeOnSelect="true"
          v-model="dataLocation"
          :options="locations"
        /><br />
        <label class="vs-select--label w-full">Select Program *</label
        ><label
          class="vs-select--label"
          @click="allProgram"
          style="float: right"
          >Select All</label
        >
        <v-select
          label="name"
          multiple
          @input="getStudent()"
          :closeOnSelect="true"
          v-model="dataProgram"
          :options="programs"
          autocomplete="off"
           name="programs"
           value=""
        /><br />
          <div class="inline-flex">
            <vs-checkbox 
              v-model="dataReminder"
              >Reminder</vs-checkbox
            >
            <div class="inline-flex mt-1" v-if="dataReminder">
            <flat-pickr :config="configDatePicker" v-model="dataDate" placeholder="Select Date"/>
            <span class="ml-4"></span>
            <flat-pickr :config="configTimePicker" v-model="dataTime" placeholder="Select Time" />
            </div>
            
            <!-- <div class="inline-flex mt-2">
             <label class="vs-select--label w-full mr-2 mt-3">Date</label> 
            <flat-pickr :config="configdateTimePicker" v-model="dataDate" placeholder="Select Date" />
            <label class="vs-select--label w-full mr-2 mt-3">Time</label> 
            <flat-pickr :config="configdateTimePicker" v-model="dataTime" placeholder="Select Time" />
            </div> -->
          </div>
          <br>
        <label class="vs-select--label w-full">Message *</label>
        <vs-textarea
          label=""
          id="textid"
          v-model="dataMessage"
          name="message"
          v-validate="'required'"
        />
        <div :id="'div-with-alert'" class="vs-con-loading__container flex-inline vx-col w-full" :ref="'div-with-alert'" >
        <span style="float:left" class="vx-col w-full">
          <label for="" class="mr-5">Attach a File</label> 
          <input type="file" multiple  ref="AlertUpdatefileInput"   @change="AlertUploadFile"  accept="*" >
             <!-- <input
              type="file"
              multiple
              class="hidden"
              ref="AlertUpdatefileInput"
              @change="AlertUploadFile"
              accept="*" />
            <feather-icon
              icon="PaperclipIcon"
              class="ml-1"
              @click="$refs.AlertUpdatefileInput.click()"
            ></feather-icon> -->
        </span>
        <span v-if="AlertUplodedfiles.length>0">
          <span v-for="(file, index) in AlertUplodedfiles" :key="index" >
            <vs-chip
              @click="AlertRemovefile(index)"
              closable
              class="leading-none font-medium"
              >{{ file.orignal }}</vs-chip>
          </span>
          </span>
          </div>
          <div>
           <span v-if="AlertlargeFile.length > 0" class="text-danger text-sm">
           <p>Large Files</p>  
          <span v-for="(file, i) in AlertlargeFile" :key="i" >
             <vs-chip class="leading-none font-medium">{{ file }}</vs-chip>
          </span>
          <br /><br />
          </span>
        </div>
        <div class="vx-row mb-1 mt-5" >
          <div class="vx-col w-full">
            <vs-checkbox v-if="!select"
              class="inline-flex"
              v-model="dataSms"
              :disabled="select"
              >Send SMS Notification</vs-checkbox
            >
            <!-- <vs-checkbox v-if="!select"
              class="inline-flex"
              v-model="dataInstant"
              :disabled="select"
              >Instant Message</vs-checkbox
            > -->
          <!-- <span v-if="dataInstant"
            :id="'div-with-alert'"
            class="vs-con-loading__container inline-flex"
            :ref="'div-with-alert'"
          >
            <input
              type="file"
              multiple
              class="hidden"
              ref="AlertUpdatefileInput"
              @change="AlertUploadFile"
              accept="*" />
            <feather-icon
              icon="PaperclipIcon"
              class="ml-1"
              @click="$refs.AlertUpdatefileInput.click()"
            ></feather-icon
          ></span> -->
                    <!-- <label for="" class="mr-5">Attach a File</label>  -->
            <!-- <input type="file" multiple  ref="AlertUpdatefileInput"   @change="AlertUploadFile"  accept="*" > -->
          </div>
        </div>
        <div v-if="students.length > 0" class="ml-2 mb-2">
           <input type="checkbox"  @change="SelectAllChip()"  class="inline-flex" v-model="chipcheck"/>
           <small class="ml-1">Select All</small>
        </div>
        <span v-for="(student, index) in students" :key="index" class="student">
          <vs-chip  v-if="student.users.length==0">
            <input type="checkbox" class="mr-5" v-model="student.instant" />
            <vs-avatar v-if="student.image" class="coverimg" :src="img_cdn + student.image" />
            <vs-avatar v-else />
           
            <vs-tooltip  :text="'This '+$t('student.titlesmall')+' does not have any '+$t('user.titlesmall')+'s, who could receive sms.'"  position="top">
              <p class="text-warning">{{ student.fname }} {{ student.lname }}</p>
            </vs-tooltip>
          </vs-chip >
           <vs-chip v-else>
             <input type="checkbox" class="mr-5" v-model="student.instant" />
            <vs-avatar v-if="student.image" class="coverimg" :src="img_cdn + student.image" />
            <vs-avatar v-else />
             {{ student.fname }} {{ student.lname }}
           </vs-chip>
        </span>
        <div slot="footer" style="float: right" class="mt-5">
          <vs-button
            class="vs-con-loading__container"
            ref="loadableButton"
            id="button-with-loading"
            @click.native="submitData"
            :disabled="!isFormValid"
            >{{ $t("student.add.btn_submit") }}</vs-button
          >
        </div>
      </div>
    </vs-popup>
    {{ closepopup }}
  </div>
</template>

<script>
import ChatProgram from './ChatProgram'
import ChatProgramNavbar from './ChatProgramNavbar'
import ChatContact from './ChatContact'
import ChatLog from './ChatLog'
import ChatNavbar from './ChatNavbar'
import UserProfile from './UserProfile'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleChat from '@/store/chat/moduleChat'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'

import {
  SEND_MSG,
  SEND_PROGRAM_MSG,
  GET_STUDENT_MESSAGE,
  GET_PROGRAM_MESSAGE,
  ADMIN_CHAT_STUDENT,
  ALL_ALERT,
  CREATE_ALERT,
  UPDATE_ANNOUNCEMENT,
  DROPDOWN_ALL_LOCATIONS,
  GET_PROGRAM_BY_LOCATIONS,
  GET_STUDENT_BY_PROGRAMS,
  MANAGER_LOCATION,
  GET_TEACHER_PROGRAM_BY_LOCATIONS,
  USER_LOCATION,
  MANAGER_CHAT_STUDENT,
  ALL_PROGRAMS_QUERY,
  MANAGER_PROGRAMS,
  TEACHER_PROGRAMS,
  USER_PROGRAMS,
  TEACHER_CHAT_STUDENT,
  USER_CHAT_STUDENT,
  ADMIN_CHAT_PROGRAMS,
  CREATE_ALERT_PROGRAM 
} from '@/graphql'
import S3 from 'aws-s3'
const config = {
  bucketName: process.env.VUE_APP_AWS_BUCKET,
  dirName: process.env.VUE_APP_AWS_DIREC,
  region: process.env.VUE_APP_AWS_DEFAULT_REGION,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  s3Url: process.env.VUE_APP_AWS_s3Url
}
const S3Client = new S3(config)

export default {
  data () {
    return {
      active: true,
      isHidden: false,
      searchContact: '',
      activeProfileSidebar: false,
      activeChatUser: null,
      userProfileId: -1,
      typedMessage: '',
      isChatPinned: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7
      },
      clickNotClose: true,
      isChatSidebarActive: true,
      isLoggedInUserProfileView: false,
      student: [],
      program: [],
      userChatData: [],
      role: '',
      AlertPopup: false,
      dataMessage: '',
      locations: [],
      programs: [],
      students: [],
      dataLocation: '',
      dataProgram: '',
      btnDisable: true,
      dataInstant: true,
      dataSms: false,
      meRole: '',
      meID: '',
      img_cdn:process.env.VUE_APP_AWS_s3Url+"/",
      chipcheck: true,
      selected: 'student',
      uplodedfiles: [],
      largeFile: [],
      AlertlargeFile:[],
      AlertUplodedfiles:[],
      chatloader:false,
      typeData:"type_student",
      newtypeData:"type_student",
      dataReminder:false,
      dataDate:'',
      dataTime:'',
      configDatePicker: {
        dateFormat: 'm/d/Y'
      },
      configTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true
      },
      activeLoading:false      
    }
  },
  watch: {
    windowWidth () {
      this.setSidebarWidth()
    },
    typeData(val){
      this.uplodedfiles= []
      this.largeFile= []
      this.AlertlargeFile=[]
      this.AlertUplodedfiles=[]
      this.dataMessage= ''
      this.dataReminder=false
      this.dataDate=''
      this.dataTime=''
      this.$refs.AlertUpdatefileInput.value=''
      this.dataLocation =''
      this.dataProgram = ''
    },
    AlertPopup(val){
      this.uplodedfiles= []
      this.largeFile= []
      this.AlertlargeFile=[]
      this.AlertUplodedfiles=[]
      this.dataMessage= ''
      this.dataReminder=false
      this.dataDate=''
      this.dataTime=''
      this.$refs.AlertUpdatefileInput.value=''
      this.dataLocation = ''
      this.dataProgram = ''
      if(val){
         this.typeData=this.newtypeData
      }
      
      
    }
  },
  computed: {
    chatLastMessaged () {
      return (userId) => this.$store.getters['chat/chatLastMessaged'](userId)
    },
    chatUnseenMessages () {
      return (userId) => {
        const unseenMsg = this.$store.getters['chat/chatUnseenMessages'](
          userId
        )
        if (unseenMsg) return unseenMsg
      }
    },
    activeUser () {
      return this.$store.state.AppActiveUser
    },
    getStatusColor () {
      return (isActiveUser) => {
        const userStatus = this.getUserStatus(isActiveUser)

        if (userStatus === 'online') {
          return 'success'
        } else if (userStatus === 'do not disturb') {
          return 'danger'
        } else if (userStatus === 'away') {
          return 'warning'
        } else {
          return 'grey'
        }
      }
    },
    // chatContacts () {
    //   return this.$store.getters['chat/chatContacts']
    // },
    contacts () {
      return this.$store.getters['chat/contacts']
    },
    studentcontacts () {
      return this.student
    },
    programcontact () {
      return this.program
    },
    programcontactslength () {
      return this.program.length
    },
    studentcontactslength () {
      return this.student.length
    },
    searchQuery: {
      get () {
        return this.$store.state.chat.chatSearchQuery
      },
      set (val) {
        this.$store.dispatch('chat/setChatSearchQuery', val)
      }
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    },
    isActiveChatUser () {
      if (this.activeChatUser) {
        return (user) => user === this.activeChatUser.id
      }
      return (user) => false
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    isFormValid () {
      if(this.typeData=='type_student'){
        return (
        !this.errors.any() &&
        this.dataMessage &&
        this.dataLocation &&
        this.dataProgram &&
        this.students &&
        this.students.length>0 &&
        this.btnDisable &&
        (this.dataInstant || this.dataSms)
      )

      }
      else{
         return (
        !this.errors.any() &&
        this.dataMessage &&
        this.dataLocation &&
        this.dataProgram &&
        this.dataProgram.length>0 &&
        this.students &&
        this.btnDisable &&
        (this.dataInstant || this.dataSms)
      )
      }

    },
    isFormValidMessage () {
      return !this.errors.any() && this.typedMessage
    },
    select () {
      const select = this.typeData
      this.dataLocation = []
      this.dataProgram = []
      this.students = []
      if (select === 'type_manager') {
        this.dataSms = false
        this.dataInstant = true
        return true
      } else {
        this.dataSms = false
        this.dataInstant = true
      }
    },
    closepopup () {
      if (!this.AlertPopup) {
        if (this.meRole == 'teacher') {
          this.dataMessage = ''
          this.dataProgram = ''
          this.dataId = null
          this.students = []
          this.btnDisable = true
          this.dataInstant = true
          this.dataSms = false
          this.chipcheck = true
          this.AlertlargeFile = []
          this.AlertUplodedfiles = []
          this.dataReminder = false
          this.dataDate = null
          this.dataTime = null
        } else {
          this.initValues()
        }
      }
    }

  },
  methods: {
    markread(val){
     if(val.type==='student'){
     this.student.forEach(student => {
       if(student.id===val.student){
         if(student.message){
          student.message.counter=0
         }
       }
     }); 
     }
    },
    removefile (file) {
      this.uplodedfiles.splice(file, 1)
    },
    openLoadingInDiv () {
      this.$vs.loading({
        type: 'sound',
        container: '#div-with-',
        scale: 0.6
      })
    },
    uploadFile () {
      const largeFile = []
      for (let i = 0; i < this.$refs.updatefileInput.files.length; i++) {
        const limit = 1024 * 1024 * 2048
        if (this.$refs.updatefileInput.files[i].size > limit) {
          largeFile.push(this.$refs.updatefileInput.files[i].name)
        } else {
          const file = this.$refs.updatefileInput.files[i]
          const orignal_name = this.$refs.updatefileInput.files[i].name
          const name = Math.random().toString().slice(2)
          this.openLoadingInDiv()
          S3Client.uploadFile(file, name)
            .then((response) => {
              this.$vs.loading.close('#div-with- > .con-vs-loading')
              this.SaveFile(response, orignal_name)
            })
            .catch((err) => console.error(err))
        }
      }
      this.largeFile = largeFile
    },
    SaveFile (response, orignal_name) {
      if (response) {
        this.uplodedfiles.push({
          orignal: orignal_name,
          new: response.key,
          link: response.location
        })
      }
    },
    AlertRemovefile (file) {
      this.AlertUplodedfiles.splice(file, 1)
    },
    openLoadingfile () {
      this.$vs.loading({
        type: 'sound',
        container: '#div-with-alert',
        scale: 0.6
      })
    },
    AlertUploadFile () {
      const largeFile = []
      for (let i = 0; i < this.$refs.AlertUpdatefileInput.files.length; i++) {
        const limit = 1024 * 1024 * 2048
        if (this.$refs.AlertUpdatefileInput.files[i].size > limit) {
          largeFile.push(this.$refs.AlertUpdatefileInput.files[i].name)
        } else {
          const file = this.$refs.AlertUpdatefileInput.files[i]
          const orignal_name = this.$refs.AlertUpdatefileInput.files[i].name
          const name = Math.random().toString().slice(2)
          this.openLoadingfile()
          S3Client.uploadFile(file, name)
            .then((response) => {
              this.$vs.loading.close('#div-with-alert > .con-vs-loading')
              this.SaveAlertFile(response, orignal_name)
            })
            .catch((err) => console.error(err))
        }
      }
      this.AlertlargeFile = largeFile
    },
    SaveAlertFile (response, orignal_name) {
      if (response) {
        this.AlertUplodedfiles.push({
          orignal: orignal_name,
          new: response.key,
          link: response.location
        })
      }
    },
    SelectAllChip () {
      if (this.chipcheck) {
        for (let index = 0; index < this.students.length; index++) {
          this.students[index].instant = true
        }
      } else {
        for (let index = 0; index < this.students.length; index++) {
          this.students[index].instant = false
        }
      }
    },
    allLocation () {
      if (this.dataLocation.length === this.locations.length) {
        this.dataLocation = []
      } else {
        this.dataLocation = this.locations
      }
      this.getProgram()
    },
    allProgram () {
      if (this.dataProgram.length === this.programs.length) {
        this.dataProgram = []
      } else {
        this.dataProgram = this.programs
      }
      this.getStudent()
    },
    getProgram () {
      this.students = []
      this.programs = []
      this.dataProgram = ''
      const locations = []
      if (this.dataLocation.length > 0) {
        for (let i = 0; i < this.dataLocation.length; i++) {
          locations.push(this.dataLocation[i].id)
        }
        if (this.meRole == 'teacher') {
          this.$apollo
            .mutate({
              mutation: GET_TEACHER_PROGRAM_BY_LOCATIONS,
              variables: {
                teacher_id: this.meID,
                location_id: locations
              }
            })
            .then((response) => {
              if (response) {
                for (
                  let index = 0;
                  index < response.data.teacher_locations_programs.length;
                  index++
                ) {
                  this.programs.push(
                    response.data.teacher_locations_programs[index]
                  )
                }
              }
            })
            .catch((error) => {
              console.log(error)
            })
        } else {
          this.$apollo
            .mutate({
              mutation: GET_PROGRAM_BY_LOCATIONS,
              variables: {
                location_id: locations
              }
            })
            .then((response) => {
              if (response) {
                for (
                  let index = 0;
                  index < response.data.locations_programs.length;
                  index++
                ) {
                  this.programs.push(response.data.locations_programs[index])
                }
              }
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    },
    getStudent () {
      if (this.typeData === 'type_student') {
        this.dataSms = false
        this.dataInstant = true
        this.students = []
        const program = []
        if (this.dataProgram.length > 0) {
          for (let i = 0; i < this.dataProgram.length; i++) {
            program.push(this.dataProgram[i].id)
          }
          this.$apollo
            .mutate({
              mutation: GET_STUDENT_BY_PROGRAMS,
              variables: {
                program_id: program
              }
            })
            .then((response) => {
              if (response) {
                const filterUser = []
                const listStudent = response.data.programsStudent
                // this.students = listStudent
                if (listStudent.length > 0) {
                  for (let i = 0; i < listStudent.length; i++) {
                   
                    listStudent[i].instant = true
                    if (listStudent[i].users.length > 0) {
                      const listusers = []
                      for (let j = 0; j < listStudent[i].users.length; j++) {
                        const user = listStudent[i].users[j]
                        if (user.phone_verified && user.pivot.alert && user.pivot.black_list==false) {
                          user.check = true
                          if (filterUser.indexOf(user.id) == -1) {
                            user.active = true
                            filterUser.push(user.id)
                            listusers.push(user)
                          } else {
                            user.active = false
                            listusers.push(user)
                          }
                        }
                      }

                      listStudent[i].users = listusers
                    }
                    // if (listStudent[i].users.length > 0) {
                      this.students.push(listStudent[i])
                    // }
                  }
                }
              }
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    },
    StatusSuccess (msg) {
      this.$vs.notify({
        title: 'Alert',
        text: msg,
        color: 'success',
        position: 'top-right'
      })
    },
    closeAlertPopup () {
      this.AlertPopup = false
    },
    openLoadingContained () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: this.$refs.loadableButton.$el,
        scale: 0.45
      })
    },
    submitData () {
      let message
      if (this.dataReminder) {
        this.dataTime = moment(String(this.dataTime), 'h:mm A').format('h:mm A')
        message = `Reminder: ${  this.dataDate  } ${  this.dataTime  } ${  this.dataMessage}`
      } else {
        message = this.dataMessage
      }
      this.btnDisable = false
      this.openLoadingContained()
      if (this.typeData === 'type_student') {
        const lastusers = []
        const laststudent = []
        if (this.students.length > 0) {
          for (let i = 0; i < this.students.length; i++) {
            if (this.students[i].instant) {
              laststudent.push(this.students[i].id)
              for (let j = 0; j < this.students[i].users.length; j++) {
                if (
                  this.students[i].users[j].check &&
                  this.students[i].users[j].pivot.alert
                ) {
                  this.students[i].users[j]['student_name']=this.students[i].fname+" "+this.students[i].lname
                  lastusers.push(this.students[i].users[j])
                }
              }
            }
          }
        }
        
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$apollo
              .mutate({
                mutation: CREATE_ALERT,
                variables: {
                  msg: message,
                  instant: this.dataInstant,
                  sms: this.dataSms,
                  users: lastusers,
                  students: laststudent,
                  files: this.AlertUplodedfiles,
                  reminder:this.dataReminder
                }
              })
              .then((response) => {
                if (response) {
                  this.$vs.loading.close(this.$refs.loadableButton.$el)
                  this.btnDisable = true
                  if (response.data.createAlert.status == 'Success') {
                    this.StatusSuccess(response.data.createAlert.message)
                    this.initValues()
                  }
                }
                this.closeAlertPopup()
              })
              .catch((error) => {
                this.$vs.loading.close(this.$refs.loadableButton.$el)
                this.btnDisable = true
              })
          }
        })
      }
      if (this.typeData === 'type_manager') {
        const lastprograms = []
        for (let index = 0; index < this.dataProgram.length; index++) {
          lastprograms.push(this.dataProgram[index].id)
        }
        this.$apollo
          .mutate({
            mutation: CREATE_ALERT_PROGRAM,
            variables: {
              msg: message,
              programs: lastprograms,
              files: this.AlertUplodedfiles,
              reminder:this.dataReminder
            }
          })
          .then((response) => {
            if (response) {
              this.$vs.loading.close(this.$refs.loadableButton.$el)
              this.btnDisable = true
              if (response.data.createAlertProgram.status == 'Success') {
                this.StatusSuccess(response.data.createAlertProgram.message)
                this.initValues()
              }
            }
            this.closeAlertPopup()
          })
          .catch((error) => {
            console.log(error)
            this.$vs.loading.close(this.$refs.loadableButton.$el)
            this.btnDisable = true
          })
      }
    },
    initValues () {
      this.dataLocation = ''
      this.dataMessage = ''
      this.dataProgram = ''
      this.dataId = null
      this.programs = []
      this.students = []
      this.btnDisable = true
      this.dataInstant = true
      this.dataSms = false
      this.chipcheck = true
      this.AlertlargeFile = []
      this.AlertUplodedfiles = []
      this.dataReminder = false
      this.dataDate = null
      this.dataTime = null
    },
   
  
    get () {

      let userId= localStorage.getItem('userId');
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      userRole = userRole[0].name
      this.meRole = userRole
      this.meID = userId
      this.conditionMethod(userRole,userId)
    },
    conditionMethod (role, id) {
      if (role === 'manager') {
        this.$apollo
          .mutate({
            mutation: MANAGER_LOCATION,
            variables: {
              id
            }
          })
          .then((response) => {
            this.locations = response.data.user.managerlocations
          })
          .catch((error) => {
            console.log(error)
          })
      } else if (role === 'teacher') {
        this.$apollo
          .mutate({
            mutation: USER_LOCATION,
            variables: {
              id
            }
          })
          .then((response) => {
            this.locations = response.data.user.locations
            this.allLocation()
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        this.$apollo
          .mutate({
            mutation: DROPDOWN_ALL_LOCATIONS
          })
          .then((response) => {
            this.locations = response.data.dropdownlocations
          })
      }
    },
    addNewData () {
      // this.selected = val
      // if(val === 'student'){
      // this.alertTile = `Add New Alert (${this.$t('student.profile.students')})`
      // }
      // else{
      //   this.alertTile = "Add New Alert (Programs)"
      // }
      this.AlertPopup = true
    },
    getUserStatus (isActiveUser) {
      // return "active"
      return isActiveUser
        ? this.$store.state.AppActiveUser.status
        : this.contacts[this.activeChatUser].status
    },
    closeProfileSidebar (value) {
      this.activeProfileSidebar = value
    },
    updateActiveChatUser (contact) {
      this.chatloader = true
      this.userChatData = []
      if (this.selected === 'student') {
        this.getStudentMsg(contact.id)
      }
      if (this.selected === 'manager') {
        this.getProgramMsg(contact.id)
      }
      this.activeChatUser = contact
      if (this.$store.getters['chat/chatDataOfUser'](contact.id)) {
        this.$store.dispatch('chat/markSeenAllMessages', contact.id)
      }
      // const chatData = this.$store.getters['chat/chatDataOfUser'](contact.id)
      // if (chatData) this.isChatPinned = chatData.isPinned
      // else this.isChatPinned = false
      this.toggleChatSidebar()
      this.typedMessage = ''
    },
    showProfileSidebar (userId, openOnLeft = false) {
      this.userProfileId = userId
      this.isLoggedInUserProfileView = openOnLeft
      this.activeProfileSidebar = !this.activeProfileSidebar
    },
    getStudentMsg (contact) {
      this.$apollo
        .mutate({
          mutation: GET_STUDENT_MESSAGE,
          variables: {
            student: contact
          }
        })
        .then((response) => {
          if (response) {
             var all_chat=[]
            response.data.getStudentMsg.forEach(element => {
               if(element.user_id){
                  all_chat.push(element)
               }
            });
           
            const result = all_chat.reduce((acc, value) => {
              
              // compare the current value with the last item in the collected array
              if (acc.length && acc[acc.length - 1][0].user_id.id == value.user_id.id) {
                // append the current value to it if it is matching
                acc[acc.length - 1].push(value)
              } else {
                // append the new value at the end of the collected array
                acc.push([value])
              }

              return acc

            }, [])
              
            // console.log(result);
            // this.userChatData = response.data.getStudentMsg
            this.userChatData = result
            this.chatloader = false
          }
        })
        .catch((error) => {
          console.log(error)
          this.chatloader = false
        })
    },
    getProgramMsg (contact) {
      this.$apollo
        .mutate({
          mutation: GET_PROGRAM_MESSAGE,
          variables: {
            program: contact
          }
        })
        .then((response) => {
          if (response) {
            var all_program=[]
            response.data.getProgramMsg.forEach(element => {
              if(element.user_id){
                all_program.push(element)
              }
            });
            const result = all_program.reduce((acc, value) => {
              // compare the current value with the last item in the collected array
              if (acc.length && acc[acc.length - 1][0].user_id.id == value.user_id.id) {
                // append the current value to it if it is matching
                acc[acc.length - 1].push(value)
              } else {
                // append the new value at the end of the collected array
                acc.push([value])
              }

              return acc
            }, [])
              
            this.userChatData = result
            this.chatloader = false
          }
        })
        .catch((error) => {
          console.log(error)
          this.chatloader = false
        })
    },
    sendMsg () {
      if (this.selected === 'student') {
        this.$apollo
          .mutate({
            mutation: SEND_MSG,
            variables: {
              student_id: this.activeChatUser.id,
              msg: this.typedMessage,
              files: this.uplodedfiles
            }
          })
          .then((response) => {
            if (response) {
              if (response.data.sendMsg.status === 'Success') {
                // this.StatusSuccess();
                // this.getStudentMsg(this.activeChatUser.id)
                this.initValues()
              }
            }
          })
          .catch((error) => {
            console.log(error)
          })
        this.largeFile = []
        this.uplodedfiles = []
      }
      if (this.selected === 'manager') {
        this.$apollo
          .mutate({
            mutation: SEND_PROGRAM_MSG,
            variables: {
              program_id: this.activeChatUser.id,
              msg: this.typedMessage,
              files: this.uplodedfiles
            }
          })
          .then((response) => {
            if (response) {
              if (response.data.sendProgramMsg.status === 'Success') {
                // this.StatusSuccess();
                this.getProgramMsg(this.activeChatUser.id)
                // this.initValues()
              }
            }
          })
          .catch((error) => {
            console.log(error)
          })
        this.largeFile = []
        this.uplodedfiles = []
      }

      // if (!this.typedMessage) return
      // const payload = {
      //   'isPinned': this.isChatPinned,
      //   'msg': {
      //     'textContent' : this.typedMessage,
      //     'time'        : String(new Date()),
      //     'isSent'      : true,
      //     'isSeen'      : false
      //   },
      //   'id': this.activeChatUser
      // }
      // this.$store.dispatch('chat/sendChatMessage', payload)
      this.typedMessage = ''

      const scroll_el = this.$refs.chatLogPS.$el || this.$refs.chatLogPS
      scroll_el.scrollTop = this.$refs.chatLog.scrollHeight
    },
    toggleIsChatPinned (value) {
      this.isChatPinned = value
    },
    setSidebarWidth () {
      if (this.windowWidth < 1200) {
        this.isChatSidebarActive = this.clickNotClose = false
      } else {
        this.isChatSidebarActive = this.clickNotClose = true
      }
    },
    toggleChatSidebar (value = false) {
      if (!value && this.clickNotClose) return
      this.isChatSidebarActive = value
    },
    getFirst(){
        if (this.$store.getters.getStudent) {
            var stud_id = this.$store.getters.getStudent
            var citrus='';
              for (let i = 0; i < this.student.length; i++) { 
                if (this.student[i].id === stud_id) 
                { 
                   citrus = this.student[i]
                    this.student.splice(i, 1);
                } 
                }
                this.student.unshift(citrus)
                  this.$nextTick(() => {
                    this.$refs.div0li[0].$el.click()
                  })

            this.$store.dispatch('setStudent', null)
          }
    }
  },
  components: {
    VuePerfectScrollbar,
    ChatContact,
    ChatProgram,
    UserProfile,
    ChatNavbar,
    ChatProgramNavbar,
    ChatLog,
    'v-select': vSelect,
    flatPickr
  },
  created () {
    this.activeLoading = true
    this.$vs.loading({
      type:'sound'
    })
    this.program = []
    this.student = []
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    this.role = userRoles[0]['name']
    if (userRoles[0]['name'] === 'admin' || userRoles[0]['name'] === 'center' || userRoles[0]['name'] === 'kvsupport') {
        this.$apollo
          .mutate({
            mutation: ADMIN_CHAT_STUDENT
          })
          .then((response) => {
            this.student = response.data.admin_chat_student
            this.activeLoading = false
            this.$vs.loading.close()
            this.getFirst()
          })
          .catch((error) => {
            console.log(error)
             this.activeLoading = false
            this.$vs.loading.close()
          })
      // }
      // this.$apollo
      //   .mutate({
      //     mutation: ALL_PROGRAMS_QUERY
      //   })
      //   .then((response) => {
      //     console.log(response)
      //     this.program = response.data.programs
      //   })
      this.$apollo
        .mutate({
          mutation: ADMIN_CHAT_PROGRAMS
        })
        .then((response) => {
          this.program = response.data.admin_chat_programs
        })
         .catch((error) => {
            console.log(error)
          })
    } else if (userRoles[0]['name'] === 'manager') {
        this.$apollo
          .mutate({
            mutation: MANAGER_CHAT_STUDENT
          })
          .then((response) => {
            this.student = response.data.manager_chat_student
              this.activeLoading = false
            this.$vs.loading.close()
             this.getFirst()
          })
          .catch((error) => {
            console.log(error)
             this.activeLoading = false
            this.$vs.loading.close()
          })
      this.$apollo
        .mutate({
          mutation: MANAGER_PROGRAMS
        })
        .then((response) => {
          this.program = response.data.manager_programs
        })
         .catch((error) => {
            console.log(error)
          })
    } else if (userRoles[0]['name'] === 'teacher') {
        this.$apollo
          .mutate({
            mutation: TEACHER_CHAT_STUDENT
          })
          .then((response) => {
            this.student = response.data.teacher_chat_student
             this.activeLoading = false
            this.$vs.loading.close()
             this.getFirst()
          })
           .catch((error) => {
            console.log(error)
             this.activeLoading = false
            this.$vs.loading.close()
          })

      this.$apollo
        .mutate({
          mutation: TEACHER_PROGRAMS
        })
        .then((response) => {
          this.program = response.data.teacher_programs
        })
    } else {
        this.$apollo
          .mutate({
            mutation: USER_CHAT_STUDENT
          })
          .then((response) => {
            this.student = response.data.user_chat_student
            this.activeLoading = false
            this.$vs.loading.close()
             this.getFirst()
          })
          .catch((error) => {
            console.log(error)
             this.activeLoading = false
            this.$vs.loading.close()
            
          })

    }
    this.$store.registerModule('chat', moduleChat)
    this.$store.dispatch('chat/fetchContacts')
    this.$store.dispatch('chat/fetchChatContacts')
    this.$store.dispatch('chat/fetchChats')
    this.setSidebarWidth()
    this.get()
  },
  beforeDestroy () {
    this.$store.unregisterModule('chat')
  },
  mounted () {
    // Listen for the 'NewMessageNotification' event in the 'synchronized' private channel
    this.$echo.channel('synchronized').listen('NewMessageNotification', (payload) => {
      if (payload) {
        if (payload.type === 'student') {
          if (payload.message.student_id) {
            const studentIndex = this.student.findIndex(item => item.id == payload.message.student_id)
            this.student.push(...this.student.splice(0, studentIndex))
          }
        } else if (payload.message.program_id) {
          const programIndex = this.program.findIndex(item => item.id == payload.message.program_id)
          this.program.push(...this.program.splice(0, programIndex))
        }
      }
    })

    this.$store.dispatch('chat/setChatSearchQuery', '')
  },
  beforeUpdate () {
    this.$nextTick(function () {
      this.$nextTick(() => {
        //  this.click()
      })
    })
  }
}
</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/chat.scss";
</style>
<style>
.vs-tooltip{
  z-index: 99999 !important;
}
</style>